import React from "react";

import styles from "./Button.module.css";

const VARIANT_CLASS = {
  primary: styles.primary,
  outline: styles.outline,
  outlineGray: styles.outlineGray,
  text: styles.text,
  textGray: styles.textGray,
};

const SIZE_CLASS = {
  medium: styles.medium,
  small: styles.small,
  xs: styles.xs,
  large: styles.large,
};

export const Button = ({
  children,
  variant = "primary",
  size = "medium",
  startIcon: StartIcon,
  endIcon: EndIcon,
  iconButton = false,
  className = "",
  disabled,
  type = "button",
  as,
  ...rest
}) => {
  const variantClass = VARIANT_CLASS[variant] ?? VARIANT_CLASS.primary;
  const sizeClass = SIZE_CLASS[size] ?? SIZE_CLASS.medium;
  const Component = as || "button";

  const props = {
    className: `${styles.button} ${variantClass} ${sizeClass} ${iconButton ? styles.iconButton : ""} ${className}`.trim(),
    disabled,
    ...rest,
  };

  if (Component === "button") {
    props.type = type;
  }

  return (
    <Component {...props}>
      {StartIcon && <StartIcon size={18} aria-hidden />}
      {children}
      {EndIcon && <EndIcon size={18} aria-hidden />}
    </Component>
  );
};
